// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import PhotoQuality from "./photo-quality.js"
import Supplier from "./supplier.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_quality_id": {
      "column": {
        "default": null,
        "name": "photo_quality_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_quality_id",
      "selected_by_default": null,
      "translated": null
    },
    "supplier_id": {
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": false,
        "type": "uuid"
      },
      "name": "supplier_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SupplierSupportedPhotoQuality",
  "collectionKey": "supplier_supported_photo_qualities",
  "collectionName": "supplier_supported_photo_qualities",
  "i18nKey": "supplier_supported_photo_quality",
  "camelizedLower": "supplierSupportedPhotoQuality",
  "name": "SupplierSupportedPhotoQuality",
  "nameDasherized": "supplier-supported-photo-quality",
  "pluralName": "supplier_supported_photo_qualities",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoQuality",
      "collectionName": "photo_qualities",
      "foreignKey": "photo_quality_id",
      "name": "photo_quality",
      "macro": "belongs_to",
      "resource_name": "PhotoQuality",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_quality_id",
      "column": {
        "default": null,
        "name": "photo_quality_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "supplier_id",
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoQuality",
      "collectionName": "photo_qualities",
      "foreignKey": "photo_quality_id",
      "name": "photo_quality",
      "macro": "belongs_to",
      "resource_name": "PhotoQuality",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "supplier_supported_photo_quality",
  "primaryKey": "id"
}

/** Frontend model for SupplierSupportedPhotoQuality. */
export default class SupplierSupportedPhotoQuality extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoQualityId() {
    return this.readAttributeUnderscore("photo_quality_id")
  }

  /** @returns {boolean} */
  hasPhotoQualityId() {
    const value = this.photoQualityId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  supplierId() {
    return this.readAttributeUnderscore("supplier_id")
  }

  /** @returns {boolean} */
  hasSupplierId() {
    const value = this.supplierId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./photo-quality.js").default | null} */
  photoQuality() {
    return this._readBelongsToReflection({modelClass: PhotoQuality, reflectionName: "photo_quality"})
  }

  /** @returns {Promise<import("./photo-quality.js").default | null>} */
  loadPhotoQuality() {
    if (!("photoQualityId" in this)) throw new Error("Foreign key method wasn't defined: photoQualityId")

    const id = this.photoQualityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_quality",
        model: this,
        modelClass: PhotoQuality
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-quality.js").default | null>} */
  ensurePhotoQualityLoaded() {
    return this.ensureAssociationLoaded("photo_quality")
  }

  /** @returns {import("./supplier.js").default | null} */
  supplier() {
    return this._readBelongsToReflection({modelClass: Supplier, reflectionName: "supplier"})
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  loadSupplier() {
    if (!("supplierId" in this)) throw new Error("Foreign key method wasn't defined: supplierId")

    const id = this.supplierId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "supplier",
        model: this,
        modelClass: Supplier
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  ensureSupplierLoaded() {
    return this.ensureAssociationLoaded("supplier")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
